<template>
  <div id="app">
    <!-- 헤더 -->
    <Header @sideMenuToggle="sideMenuToggle" />
    <SideMenu ref="sideMenu" />
    <!--// 헤더 -->
    
    <main id="main_wrap">
      <transition name="fade" mode="out-in">      
        <router-view/>
      </transition>
    </main>
    
    <!-- 팝업 - 주소 직접입력 -->
		<div class="popup_common" id="telInfo" tabindex="0" title="전화번호 안내" v-show="isPopup">
			<div class="popup_header">
				<h4>전화번호 안내</h4><a href="#" title="전화번호 안내 닫기" @click="telPopupClose">닫기</a>
			</div>
			<ul class="popup_call">
				<li>신청접수 : 1600-4477 <a href="tel:1600-4477"><img src="./assets/images/icon_call_m.png" alt="통화하기" /></a></li>
				<li>신청접수 : 02-2092-0000 <a href="tel:02-2092-0000"><img src="./assets/images/icon_call_m.png" alt="통화하기" /></a></li>
				<li>민원 및 대절 : 02-2092-0088 <a href="tel:02-2092-0088"><img src="./assets/images/icon_call_m.png" alt="통화하기" /></a></li>
<!--				<li class="call_h">바우처 택시</li>
				<li>문의 : 02-2092-0055 <a href="tel:02-2092-0055"><img src="./assets/images/icon_call_m.png" alt="통화하기" /></a></li>
				<li>나비콜 : 1800-1133 <a href="tel:1800-1133"><img src="./assets/images/icon_call_m.png" alt="통화하기" /></a></li>
				<li>국민캡 : 02-555-0909 <a href="tel:02-555-0909"><img src="./assets/images/icon_call_m.png" alt="통화하기" /></a></li>-->
			</ul>
		</div>
		<!--// 팝업 -->
    <div class="popup_layer" v-if="isPopup"></div>

    <!-- 푸터 -->
    <Footer @telPopupShow="telPopupShow" />
    <!--// 푸터 -->
  </div>
</template>

<script>
import Header from './pages/common/Header';
import SideMenu from './pages/common/SideMenu';
import Footer from './pages/common/Footer';

export default {
  name: 'App',
  components: {
      Header,
      SideMenu,
      Footer
  },
  data() {
      return {
          isPopup: false
      }
  },    
  created() {
    if(this.$store.state.session == null && $cookies.get("t") != null) {
      this.$http.post('/api/autoLoginCheck.do').then((response) => {

      if(response.data.retval == this.CONSTANT.SUCCESS) {
        this.$store.commit("setSession", {user_id: response.data.user_id, user_name: response.data.user_name, user_tel: response.data.user_tel});
        }
      });
    }

    this.$router.beforeEach((to, from, next) => {      
      this.$refs.sideMenu.sideMenuToggle(false);
      next();
    });
  },
  methods: {
      sideMenuToggle() {
          this.$refs.sideMenu.sideMenuToggle();
      },
      telPopupShow() {
          this.isPopup = true;
          setTimeout(function() {
            //$("#telInfo").attr("tabindex", 0).focus();
            document.getElementById("telInfo").focus();
          }, 200);
      },
      telPopupClose() {
          this.isPopup = false;
      }
  }
}
</script>
<style>
.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.3s;  
  transition-property: height, opacity;
  transition-timing-function: ease;
  overflow: hidden;
}

.fade-enter,
.fade-leave-active {
  opacity: 0
}
</style>


// WEBPACK FOOTER //
// src/App.vue